import PropTypes from 'prop-types';
import useProposalStages from 'apps/proposals/hooks/use-proposal-stages';
import { AdvancedCombobox } from '@evertrue/et-components';

const StageField = ({ onChange, onBlur, name = '', value = '', required = false, field, meta, helpers }) => {
  const [proposalStages = []] = useProposalStages();

  return (
    <AdvancedCombobox
      className="proposal-form--form-field-dropdown"
      label={value ? value + ' stage selected' : 'Select stage'}
      value={proposalStages.find((stage) => stage.value === value)}
      options={proposalStages}
      placeholder="Select a stage..."
      onChange={(selected) => {
        helpers.setValue(selected?.value);
      }}
      onClose={() => {
        helpers.setTouched(true, false);
      }}
    />
  );
};

StageField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default StageField;
